import { useContext, useEffect, useState, useRef } from "react";
import { AuthContext } from "../AuthContext";
import {
  Header,
  Icon,
  Image,
  Dropdown,
  Button,
  Table,
  Label,
  Popup,
  Rating,
  Accordion,
  Segment,
  Loader,
} from "semantic-ui-react";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  USER_SEARCH,
  JOBS,
  CREATE_JOB,
  UPDATE_JOB,
  CREATE_FILE,
  GET_UPLOAD_LINK,
  GET_DOWNLOAD_LINK,
  SERVICES,
} from "../graphQueries";
import PageModal from "../PageModal/PageModal";
import RequestJob from "./RequestJob";
import moment from "moment";
import UploadTranscript from "./UploadTranscript";
import axios from "axios";
import ViewEditJob from "./ViewEditJob";
import Invoice from "./Invoice";
import UploadOrderForm from "./UploadOrderForm";
import GetPaidNow from "./GetPaidNow";
import StarRating from "./StarRating";
import RemoteEvent from "./RemoteEvent";
import JobDocuments from "./JobDocuments";
import { toast } from "react-toastify";

// Returns a Promise that resolves to a signed S3 download URL for a given file path
const useGetDownloadLink = () => {
  const [getDownloadLink] = useLazyQuery(GET_DOWNLOAD_LINK, {
    fetchPolicy: "network-only",
  });

  // path is the DB "path" field (e.g. "transcripts/xyz/transcript.pdf")
  const fetchDownloadUrl = async (path) => {
    if (!path) return null;
    const { data } = await getDownloadLink({ variables: { file: path } });
    return data?.getDownloadLink?.link || null;
  };

  return fetchDownloadUrl;
};

const Jobs = (props) => {
  const { initNewJob, setInitNewJob, initJobId, setInitJobId } = props;
  const { loginContext, themeColor } = useContext(AuthContext);
  const isAdmin = loginContext.role === "Admin";
  const isAttorney = loginContext.role === "Attorney";
  const isCSR = loginContext.role === "CSR";
  const [searchResults, setResults] = useState([]);
  const [selectedReporter, setSelectedReporter] = useState({});
  const [searchDisabled, setSearchDisabled] = useState(false);
  const [isSearching, setSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [jobsList, setJobsList] = useState([]);
  const [isRequestJob, setRequestJob] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [isUploadTranscript, setUploadTranscript] = useState(false);
  const [isUploadOrderForm, setUploadOrderForm] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [formToUpload, setFormToUpload] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [downloadingTranscript, setDownloadingTranscript] = useState(false);
  const [downloadingOrderForm, setDownloadingOrderForm] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(2);
  const [isViewEdit, setViewEdit] = useState(false);
  const [selectedTranscript, setSelectedTranscript] = useState("ASCII");
  const [selectedOrderForm, setSelectedOrderForm] = useState("PDF");
  const [requesting, setRequesting] = useState(false);
  const [editDisabled, setEditDisabled] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [isInvoice, setInvoice] = useState(false);
  const [isConfirmInvoice, setConfirmInvoice] = useState(false);
  const [isGenerating, setGenerating] = useState(false);
  const [searchMethod, setSearchMethod] = useState("Zip Code");
  const [servicesList, setServices] = useState({});
  const [serviceTotal, setServiceTotal] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [orderFormNumPages, setOrderFormNumPages] = useState(0);
  const [orderFormPageNumber, setOrderFormPageNumber] = useState(0);
  const [orderFormDownloadUrl, setOrderFormDownloadUrl] = useState("");
  const [transcriptNumPages, setTranscriptNumPages] = useState(0);
  const [transcriptPageNumber, setTranscriptPageNumber] = useState(0);
  const [transcriptPDFDownloadUrl, setTranscriptPDFDownloadUrl] = useState("");
  const [transcriptASCIIDownloadUrl, setTranscriptASCIIDownloadUrl] =
    useState("");
  const [isGetPaidNow, setGetPaidNow] = useState(false);
  const [isRating, setRating] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [initializing, setInitializing] = useState(true);
  const [isMobile, setMobile] = useState(false);
  const [preferredResults, setPreferredResults] = useState([]);
  const [isAddAttendee, setAddAttendee] = useState(false);
  const [transcriptPDFPreviewUrl, setTranscriptPDFPreviewUrl] = useState("");
  const [orderFormPreviewUrl, setOrderFormPreviewUrl] = useState("");

  const submessage = "Select a job to view details";

  const getDownloadUrl = useGetDownloadLink();

  useEffect(() => {
    jobs();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setInitializing(false);
    }, 2000);
  }, [jobsList]);

  useEffect(() => {
    if (selectedJob.transcriptPdf) {
      getDownloadUrl(selectedJob.transcriptPdf).then(
        setTranscriptPDFPreviewUrl
      );
    } else {
      setTranscriptPDFPreviewUrl("");
    }
  }, [selectedJob.transcriptPdf]);

  useEffect(() => {
    if (selectedJob.orderForm) {
      getDownloadUrl(selectedJob.orderForm).then(setOrderFormPreviewUrl);
    } else {
      setOrderFormPreviewUrl("");
    }
  }, [selectedJob.orderForm]);

  useEffect(() => {
    if (initNewJob) handleStartNewJob();
    setInitNewJob(false);
  }, [initNewJob]);

  useEffect(() => {
    handleReporterSearch();
  }, [searchQuery]);

  useEffect(() => {
    console.log(selectedJob);
    if (selectedJob.invoice) {
      console.log(JSON.parse(selectedJob.invoice));
    }
  }, [selectedJob]);

  useEffect(() => {
    if (formToUpload === null) return;
    handleUploadOrderForm();
  }, [formToUpload]);

  useEffect(() => {
    if (fileToUpload === null) return;
    handleUploadTranscript();
  }, [fileToUpload]);

  useEffect(() => {
    const handleResize = () => {
      console.log("resizing");
      if (window.innerWidth < 1400) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };

    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDownload = async ({ path, downloadName = "download" }) => {
    try {
      // Could optionally set state for "downloading"
      const url = await getDownloadUrl(path);
      if (!url) throw new Error("No download URL");
      const res = await fetch(url);
      const blob = await res.blob();

      // For direct download:
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = downloadName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Revoke later if you want (not strictly needed, GC will clean)
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    } catch (e) {
      toast.error("Download failed: " + (e?.message || "unknown"));
    }
  };

  const [createFile] = useMutation(CREATE_FILE, {
    onCompleted: () => toast.success("File uploaded!"),
    onError: (error) => toast.error(error.message),
  });

  const handleUploadFile = async ({
    file,
    type,
    path,
    filename,
    extraVariables,
    onSuccess,
  }) => {
    try {
      const { data } = await getUploadLink({ variables: { file: path } });
      if (!data?.getUploadLink?.link)
        throw new Error("No upload link returned.");
      await axios.put(data.getUploadLink.link, file, {
        headers: { "Content-Type": file.type },
      });
      await createFile({
        variables: {
          ...extraVariables,
          type,
          path,
          filename,
        },
      });
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err.message || "Upload failed.");
    }
  };

  const handleUploadTranscript = async () => {
    if (!fileToUpload) return;
    setUploading(true);

    const extraVariables = {
      userId: selectedJob.userId,
      csrUserId: loginContext.userId,
      jobId: selectedJob.jobId,
      numPages: transcriptNumPages || null,
    };
    const isPDF = fileToUpload.name.toLowerCase().endsWith(".pdf");
    const ext = isPDF ? "pdf" : "txt";
    const filename = `transcript.${ext}`;
    const path = `transcripts/${selectedJob.jobId}/${filename}`;
    await handleUploadFile({
      file: fileToUpload,
      type: isPDF ? "transcript_pdf" : "transcript_txt",
      path,
      filename,
      extraVariables,
      onSuccess: async () => {
        setUploading(false);
        toast.success("Transcript uploaded!");
        if (isPDF) {
          const url = await getDownloadUrl(path);
          setTranscriptPDFPreviewUrl(url);
        }
        jobs();
        resetState();
      },
    });
  };

  const handleUploadOrderForm = async () => {
    if (!formToUpload) return;
    setUploading(true);

    const extraVariables = {
      userId: selectedJob.userId,
      csrUserId: loginContext.userId,
      jobId: selectedJob.jobId,
      numPages: orderFormNumPages || null,
    };
    const filename = "order-form.pdf";
    const path = `orderForms/${selectedJob.jobId}/${filename}`;
    await handleUploadFile({
      file: formToUpload,
      type: "order_form",
      path,
      filename,
      extraVariables,
      onSuccess: async () => {
        setUploading(false);
        toast.success("Order form uploaded!");
        const url = await getDownloadUrl(path);
        setOrderFormPreviewUrl(url);
        jobs();
        resetState();
      },
    });
  };

  const [jobs] = useLazyQuery(JOBS, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleJobs_Result(result),
    onError: (error) => handleJobs_Error(error),
  });

  const handleJobs_Result = (result) => {
    console.log(result);
    if (result && result.jobs) {
      setJobsList(result.jobs);
      if (initJobId) {
        const job = result.jobs.filter((x) => x.jobId === initJobId);
        handleSelectJob(job[0]);
        setInitJobId("");
      }
      if (selectedJob.jobId) {
        const job = result.jobs.filter((x) => x.jobId === selectedJob.jobId);
        handleSelectJob(job[0]);
      }
    }
  };

  const handleJobs_Error = (error) => {
    console.log(error);
  };

  const [services] = useLazyQuery(SERVICES, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleServices_Result(result),
    onError: (error) => handleServices_Error(error),
  });

  const handleServices_Result = (result) => {
    console.log(result);
    if (result && result.services.length) {
      setServices(result.services[0]);
    }
  };

  const handleServices_Error = (error) => {
    console.log(error);
  };

  const [userSearch] = useLazyQuery(USER_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleUserSearch_Result(result),
    onError: (error) => handleUserSearch_Error(error),
  });

  const handleUserSearch_Result = (result) => {
    console.log(result);
    if (result && result.userSearch.length) {
      setResults(result.userSearch);
      setSearching(false);
    }
  };

  const handleUserSearch_Error = (error) => {
    console.log(error);
    setSearching(false);
  };

  const handleResultSelect = (item) => {
    setSearchDisabled(true);
    setSelectedReporter(item);
    setSearchQuery("");
    setResults([]);
  };

  const [preferredSearch] = useLazyQuery(USER_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handlePreferredSearch_Result(result),
    onError: (error) => handlePreferredSearch_Error(error),
  });

  const handlePreferredSearch_Result = (result) => {
    console.log(result);
    setPreferredResults(result.userSearch);
  };

  const handlePreferredSearch_Error = (error) => {
    console.log(error);
  };

  const handleReporterSearch = () => {
    if (searchQuery.length > 2) {
      userSearch({
        variables: {
          name: searchMethod === "Name" ? searchQuery : "",
          zipCode: searchMethod === "Zip Code" ? searchQuery : "",
          city: searchMethod === "City" ? searchQuery : "",
          start: selectedJob.start,
        },
      });
      setSearching(true);
    } else {
      setResults([]);
      setSearching(false);
    }
  };

  const handlePreferredSearch = () => {
    console.log(
      "inside handlePreferredSearch",
      loginContext.preferredReporterId
    );
    preferredSearch({
      variables: {
        id: loginContext.preferredReporterId,
        start: selectedJob.start,
      },
    });
  };

  const handleStartNewJob = () => {
    setSelectedJob({});
    setRequestJob(true);
  };

  const handleClearReporterSelection = () => {
    setSelectedReporter({});
    setSearchDisabled(false);
    setSearchQuery("");
    setResults([]);
  };

  const handleStartDate = (start) => {
    setSelectedReporter({});
    setSearchQuery("");
    setResults([]);
    setSearchDisabled();
    const obj = { ...selectedJob };
    Object.assign(obj, { start, end: new Date(moment(start).add(8, "hours")) });
    setSelectedJob(obj);
  };

  const handleEndDate = (end) => {
    setSelectedReporter({});
    setSearchQuery("");
    setResults([]);
    setSearchDisabled();
    const obj = { ...selectedJob };
    Object.assign(obj, { end });
    setSelectedJob(obj);
  };

  const handleChangeFieldString = (e, data) => {
    console.log("handleChangeFieldString", data);
    setEditDisabled(false);
    setSelectedReporter({});
    setSearchQuery("");
    setResults([]);
    setSearchDisabled();
    const key = data.id;
    let value = data.value || data.checked;
    if (
      value &&
      (key === "bill_hourlyRate" ||
        key === "billableExhibits" ||
        key === "billableHours")
    ) {
      value = value
        .replace(/^0+|[^0-9]/g, "")
        .slice(0, 5)
        .toString();
    }
    let obj = { ...selectedJob };
    Object.assign(obj, { [key]: value });
    setSelectedJob(obj);
  };

  const handleCreateJob = () => {
    if (!selectedJob.start) {
      alert("Please select a start date and time.");
      return;
    }
    if (!selectedJob.end) {
      alert("Please select an end date and time.");
      return;
    }
    if (!selectedReporter.userId) {
      alert("Pleaser select a court reporter.");
      return;
    }
    setRequesting(true);
    const obj = { ...selectedJob };
    Object.assign(obj, {
      csrUserId: selectedReporter.userId,
      status: "Requested",
    });
    createJob({ variables: obj });
  };

  const [createJob] = useMutation(CREATE_JOB, {
    onCompleted: (result) => handleCreateJob_Result(result),
    onError: (error) => handleCreateJob_Error(error),
  });

  const handleCreateJob_Result = (result) => {
    console.log(result);
    if (result && result.createJob.status === "succeeded") {
      toast.success("Job requested successfully!");
      setRequesting(false);
      jobs();
      resetState();
    }
  };

  const handleCreateJob_Error = (error) => {
    console.log(error);
    toast.error(error.message);
    resetState();
  };

  const resetState = () => {
    setRequestJob(false);
    // setSelectedJob({});
    setSelectedReporter({});
    setFileToUpload(null);
    setUploadTranscript(false);
    setRequesting(false);
    setUpdating(false);
    setViewEdit(false);
    setGenerating(false);
    setAddAttendee(false);
    setInvoice(false);
    setFormToUpload(null);
    setUploadOrderForm(false);
    setRating(false);
    setTimeout(() => {
      setEditDisabled(true);
    }, 4000);
  };

  const handleCloseRequest = () => {
    setSelectedJob({});
    setSelectedReporter({});
    setSearchQuery("");
    setResults([]);
    setPage(1);
    setFileToUpload(null);
  };

  const getStatus = (status, invoice) => {
    if (invoice) {
      return (
        <Label
          basic
          size="large"
          content={status === "Completed" ? "Completed" : "Not Completed"}
          color={status === "Completed" ? "green" : "red"}
        />
      );
    }
    return (
      <Label
        basic
        size="large"
        content={status}
        color={
          status === "Requested"
            ? "orange"
            : status === "Confirmed"
            ? "blue"
            : status === "Declined"
            ? "red"
            : status === "Completed"
            ? "green"
            : ""
        }
      />
    );
  };

  const getOrderFormDisabled = () => {
    if (downloadingOrderForm) return true;
    if (selectedJob.jobId) {
      return false;
    } else {
      return true;
    }
  };

  const getOrderFormDownloadDisabled = () => {
    if (downloadingOrderForm) return true;
    if (selectedJob.jobId && selectedJob.orderForm) {
      return false;
    } else {
      return true;
    }
  };

  const getTranscriptDisabled = () => {
    if (downloadingTranscript) return true;
    if (uploading) return true;
    if (selectedJob.jobId && selectedJob.status === "Completed") {
      return false;
    } else {
      return true;
    }
  };

  const getASCIITranscriptDownloadDisabled = () => {
    if (downloadingTranscript) return true;
    if (selectedJob.jobId && selectedJob.transcriptTxt) {
      return false;
    } else {
      return true;
    }
  };

  const getPDFTranscriptDownloadDisabled = () => {
    if (downloadingTranscript) return true;
    if (selectedJob.jobId && selectedJob.transcriptPdf) {
      return false;
    } else {
      return true;
    }
  };

  const getUploadButtonDisabled = () => {
    if (selectedJob.jobId && selectedJob.status === "Completed") {
      return false;
    } else {
      return true;
    }
  };

  const getViewDisabled = () => {
    if (Object.keys(selectedJob).length > 0) return false;
    return true;
  };

  const getRatingDisabled = () => {
    if (
      Object.keys(selectedJob).length > 0 &&
      selectedJob.status === "Completed"
    )
      return false;
    return true;
  };

  const handleGenerateInvoice = () => {
    // 1. is job marked as completed
    if (!selectedJob.status === "Completed") return;
    // 2. is transcript uploaded
    if (!selectedJob.transcriptPdf) return;
    // 3. at least one service to charge for
    if (!serviceTotal) return;
    setGenerating(true);
    setConfirmInvoice(false);
    let updateObj = { ...selectedJob };
    Object.assign(updateObj, {
      isGenerateInvoice: true,
      serviceTotal,
    });
    updateJob({ variables: updateObj });
  };

  const handleUpdateJob = (tempStatus, advancePayRequested) => {
    console.log("inside handleUpdateJob", tempStatus);
    setUpdating(true);
    setEditDisabled(true);
    let updateObj = { ...selectedJob };
    if (tempStatus) {
      Object.assign(updateObj, { status: tempStatus });
    }
    if (advancePayRequested && !selectedJob.advancePayRequested) {
      Object.assign(updateObj, { advancePayRequested });
    }
    setGetPaidNow(false);
    console.log("updateObj", updateObj);
    updateJob({ variables: updateObj });
  };

  const [updateJob] = useMutation(UPDATE_JOB, {
    onCompleted: (result) => handleUpdateJob_Result(result),
    onError: (error) => handleUpdateJob_Error(error),
  });

  const handleUpdateJob_Result = (result) => {
    console.log(result);
    if (result && result.updateJob.status === "succeeded") {
      toast.success(result.updateJob.message);
      jobs();
      resetState();
    }
    if (result && result.updateJob.status === "failed") {
      if (result.updateJob.message === "sync") {
        toast.error(
          "Failed to update, your data is out of date. Please refresh and try again."
        );
        jobs();
        resetState();
      } else {
        toast.error("Failed to update. Please try again.");
      }
    }
  };

  const handleUpdateJob_Error = (error) => {
    console.log(error);
    toast.error(error.message);
    resetState();
  };

  const [getUploadLink] = useLazyQuery(GET_UPLOAD_LINK, {
    fetchPolicy: "network-only",
  });

  const handleChangePage = (e, data) => {
    console.log(data);
    let currentPage = page;
    if (data.id === "next" && currentPage < pages) {
      currentPage = currentPage + 1;
    }
    if (data.id === "previous" && currentPage > 1) {
      currentPage = currentPage - 1;
    }
    setPage(currentPage);
    setSearchQuery("");
  };

  const getNextDisabled = () => {
    if (page === pages) return true;
    if (selectedJob.name && selectedJob.start && selectedJob.end) return false;
    return true;
  };

  const getRequestDisabled = () => {
    if (page !== pages) return true;
    if (Object.keys(selectedReporter).length > 0) return false;
    return true;
  };

  const getReporterSelected = () => {
    if (Object.keys(selectedReporter).length > 0) return true;
    return false;
  };

  const getGenerateDisabled = () => {
    if (selectedJob.invoiceId) return true;
    // 1. is job marked as completed
    if (!selectedJob.status === "Completed") return true;
    // 2. is order form uploaded
    if (!selectedJob.orderForm) return true;
    // 3. is transcript uploaded
    if (!selectedJob.transcriptPdf) return true;
    // 4. at least one service to charge for
    if (serviceTotal < 1) return true;
    return false;
  };

  const handleModalClose = () => {
    document.body.classList.remove("modal-fade-in");
    setRequestJob(false);
    setUploadTranscript(false);
    setUploadOrderForm(false);
    setViewEdit(false);
    setAddAttendee(false);
    setInvoice(false);
    setGetPaidNow(false);
    setRating(false);
  };

  const handleSelectJob = (job) => {
    setSelectedJob(job);
    if (job.csrUserId) {
      services({ variables: { csrUserId: job.csrUserId } });
    }
  };

  const getPayoutButtonDisabled = () => {
    if (!isCSR) return true;
    if (!selectedJob.invoice) return true;
    if (selectedJob.advancePayRequested) return true;
    const invoiceObj = JSON.parse(selectedJob.invoice);
    if (invoiceObj.status !== "open") return true;
    return false;
  };

  const getSidebar = () => {
    if (Object.keys(selectedJob).length > 0 && selectedJob.jobId) return true;
    return false;
  };

  const handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeMenu === index ? -1 : index;
    setActiveMenu(newIndex);
  };

  const getConfirmedCompleted = () => {
    if (
      Object.keys(selectedJob).length > 0 &&
      (selectedJob.status === "Confirmed" || selectedJob.status === "Completed")
    )
      return true;
    return false;
  };

  const SearchResults = () => {
    return searchResults.map((item, index) => {
      return (
        <Dropdown.Item
          key={index}
          onClick={() => handleResultSelect(item)}
          disabled={!item.isAvailable}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              style={{ width: "75px", height: "75px", borderRadius: "10px" }}
              src={item.photoLink}
            />
            <Header style={{ marginTop: "0px", marginLeft: "10px" }}>
              {item.fullName}
              <Header.Subheader>{item.dbaName}</Header.Subheader>
              <Header.Subheader>{item.location}</Header.Subheader>
              <Header.Subheader
                style={{ display: "flex", alignItems: "center" }}
              >
                Rating:{" "}
                {
                  <Rating
                    icon="star"
                    disabled
                    style={{ marginLeft: "5px", marginRight: "5px" }}
                    maxRating={5}
                    rating={parseInt(item.averageRating)}
                  />
                }{" "}
                (from {item.numRatings} ratings)
              </Header.Subheader>
            </Header>
            {!item.isAvailable && (
              <Label
                content="Not Available"
                color="red"
                style={{ marginLeft: "10px" }}
              />
            )}
            {item.isAvailable && (
              <Label
                content="Available"
                color="green"
                style={{ marginLeft: "10px" }}
              />
            )}
          </div>
        </Dropdown.Item>
      );
    });
  };

  const JobsList = () => {
    return jobsList.map((item, index) => {
      return (
        <Table.Row
          className="custom-button"
          active={item.jobId === selectedJob.jobId}
          key={index}
          onClick={() => handleSelectJob(item)}
        >
          <Table.Cell>{moment(item.createdAt).format("LLL")}</Table.Cell>
          <Table.Cell>{item.name}</Table.Cell>
          <Table.Cell>{item.requesterName}</Table.Cell>
          <Table.Cell>{moment(item.start).format("LLL")}</Table.Cell>
          <Table.Cell>{moment(item.end).format("LLL")}</Table.Cell>
          <Table.Cell>{item.reporterName}</Table.Cell>
          <Table.Cell>{getStatus(item.status)}</Table.Cell>
          <Table.Cell>
            {item.transcriptTxt && !item.transcriptPdf ? (
              <Popup
                trigger={<Icon name="clock" color="yellow" size="large" />}
                on="hover"
                content="ASCII file uploaded, waiting for PDF conversion."
              />
            ) : null}
            {item.transcriptPdf ? (
              <Popup
                trigger={<Icon name="check" color="green" size="large" />}
                on="hover"
                content="PDF file uploaded."
              />
            ) : null}
          </Table.Cell>
          <Table.Cell>
            {item.orderForm ? (
              <Popup
                trigger={<Icon name="check" color="green" size="large" />}
                on="hover"
                content="PDF file uploaded."
              />
            ) : null}
          </Table.Cell>
          <Table.Cell>
            {item.rating ? (
              <Rating
                disabled
                icon="star"
                rating={parseInt(item.rating)}
                maxRating={5}
              />
            ) : null}
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "calc(100% - 50px)",
        position: "absolute",
        backgroundColor: "#ffffff",
        top: "50px",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          width: "100%",
          height: "100%",
          display: "flex",
          padding: 20,
        }}
      >
        <div
          id="leftColumn"
          style={{
            borderRight: "1px solid #c3c3c3",
            // margin: "10px",
            padding: "10px",
            flex: isMobile && getSidebar() ? 1 : getSidebar() ? 1.3 : 2.0,
            width: "50%",
            transition: "flex 0.3s ease",
          }}
        >
          <Header as="h1" content="Jobs" subheader={submessage} />
          <div className="table-container">
            <Table sortable style={{ border: "none" }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell sorted="descending">
                    Created
                  </Table.HeaderCell>
                  <Table.HeaderCell>Case</Table.HeaderCell>
                  <Table.HeaderCell>Requester</Table.HeaderCell>
                  <Table.HeaderCell>Start</Table.HeaderCell>
                  <Table.HeaderCell>End</Table.HeaderCell>
                  <Table.HeaderCell>Reporter</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Transcript</Table.HeaderCell>
                  <Table.HeaderCell>Order Form</Table.HeaderCell>
                  <Table.HeaderCell>Rating</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <JobsList />
              </Table.Body>
            </Table>
            {initializing && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 150, // or whatever height fits well
                  width: "100%",
                }}
              >
                <Loader size="large" content="Loading Jobs..." active />
              </div>
            )}
          </div>

          <PageModal
            open={isRequestJob}
            setOpen={setRequestJob}
            heading="Request New Job"
            styles={{ minHeight: "300px" }}
            resetState={handleCloseRequest}
            scrolling
            actions={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  content="Cancel"
                  size="large"
                  onClick={handleModalClose}
                />
                <div>
                  <Button
                    id="previous"
                    icon="left arrow"
                    labelPosition="left"
                    primary
                    content="Previous"
                    size="large"
                    onClick={handleChangePage}
                    disabled={page === 1}
                  />
                  <Button
                    id="next"
                    icon="right arrow"
                    labelPosition="right"
                    primary
                    content="Next"
                    size="large"
                    onClick={handleChangePage}
                    disabled={getNextDisabled()}
                  />
                  <Button
                    positive
                    content="Request"
                    size="large"
                    onClick={handleCreateJob}
                    disabled={requesting || getRequestDisabled()}
                    loading={requesting}
                  />
                </div>
              </div>
            }
          >
            <RequestJob
              isSearching={isSearching}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              searchResults={searchResults}
              handleReporterSearch={handleReporterSearch}
              SearchResults={SearchResults}
              selectedJob={selectedJob}
              selectedReporter={selectedReporter}
              searchDisabled={searchDisabled}
              handleClearReporterSelection={handleClearReporterSelection}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              handleChangeFieldString={handleChangeFieldString}
              page={page}
              searchMethod={searchMethod}
              setSearchMethod={setSearchMethod}
              setResults={setResults}
              handlePreferredSearch={handlePreferredSearch}
              preferredResults={preferredResults}
              handleResultSelect={handleResultSelect}
              getReporterSelected={getReporterSelected}
            />
          </PageModal>
        </div>
        <div
          id="right"
          style={{
            // margin: "10px",

            padding: "10px",
            flex: isMobile && getSidebar() ? 1 : getSidebar() ? 0.7 : 0,
            width: "50%",
            transition: "flex 0.3s ease",
          }}
        >
          {getSidebar() && (
            <div>
              <Header
                content="Details"
                as="h1"
                subheader="View/edit selected job details"
              />
              <Icon
                onClick={() => setSelectedJob({})}
                className="custom-button"
                style={{ position: "absolute", right: "10px", top: "10px" }}
                size="large"
                name="close"
              />
            </div>
          )}

          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 250px)",
              transition: "height 0.3 ease",
              border: "1px solid #D5D5D5",
              backgroundColor: "#F1F1F1",
              borderRadius: "5px",
            }}
          >
            <Accordion>
              {getSidebar() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 0}
                    index={0}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      content="Service Info"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 0}>
                    <ViewEditJob
                      selectedJob={selectedJob}
                      selectedReporter={selectedReporter}
                      handleChangeFieldString={handleChangeFieldString}
                      setSelectedJob={setSelectedJob}
                      editDisabled={editDisabled}
                      setEditDisabled={setEditDisabled}
                      servicesList={servicesList}
                      themeColor={themeColor}
                      getConfirmedCompleted={getConfirmedCompleted}
                      handleUpdateJob={handleUpdateJob}
                      updating={updating}
                    />
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && selectedJob?.meeting && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 1}
                    index={1}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      content="Remote Event"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 1}>
                    <RemoteEvent
                      selectedJob={selectedJob}
                      setSelectedJob={setSelectedJob}
                      loginContext={loginContext}
                      handleUpdateJob={handleUpdateJob}
                      isAddAttendee={isAddAttendee}
                      setAddAttendee={setAddAttendee}
                      updating={updating}
                    />
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && !isAttorney && getConfirmedCompleted() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 2}
                    index={2}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      basic
                      content="Order Form"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 2}>
                    <div>
                      <UploadOrderForm
                        setSelectedOrderForm={setSelectedOrderForm}
                        selectedOrderForm={selectedOrderForm}
                        formToUpload={formToUpload}
                        setFormToUpload={setFormToUpload}
                        uploading={uploading}
                        uploadProgress={uploadProgress}
                        orderFormNumPages={orderFormNumPages}
                        orderFormPageNumber={orderFormPageNumber}
                        setOrderFormPageNumber={setOrderFormPageNumber}
                        setOrderFormNumPages={setOrderFormNumPages}
                        selectedJob={selectedJob}
                        pdfPreviewUrl={orderFormPreviewUrl}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <Button
                          loading={downloadingOrderForm}
                          disabled={getOrderFormDownloadDisabled()}
                          positive
                          content="Download PDF"
                          icon="download"
                          size="large"
                          onClick={() =>
                            handleDownload({
                              path: selectedJob.orderForm,
                              downloadName: "OrderForm.pdf",
                            })
                          }
                        />
                      </div>
                    </div>
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && getConfirmedCompleted() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 3}
                    index={3}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      basic
                      content="Transcript"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 3}>
                    <div>
                      <UploadTranscript
                        pdfPreviewUrl={transcriptPDFPreviewUrl}
                        setSelectedTranscript={setSelectedTranscript}
                        fileToUpload={fileToUpload}
                        setFileToUpload={setFileToUpload}
                        uploading={uploading}
                        uploadProgress={uploadProgress}
                        transcriptNumPages={transcriptNumPages}
                        setTranscriptNumPages={setTranscriptNumPages}
                        transcriptPageNumber={transcriptPageNumber}
                        setTranscriptPageNumber={setTranscriptPageNumber}
                        isAttorney={isAttorney}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <Button
                          loading={downloadingTranscript}
                          disabled={getPDFTranscriptDownloadDisabled()}
                          positive
                          content="Download PDF"
                          icon="download"
                          size="large"
                          onClick={() =>
                            handleDownload({
                              path: selectedJob.transcriptPdf,
                              downloadName: "Transcript.pdf",
                            })
                          }
                        />
                        {!isAttorney && (
                          <Button
                            loading={downloadingTranscript}
                            disabled={getASCIITranscriptDownloadDisabled()}
                            positive
                            content="Download TXT"
                            icon="download"
                            size="large"
                            onClick={() =>
                              handleDownload({
                                path: selectedJob.transcriptTxt,
                                downloadName: "Transcript.txt",
                              })
                            }
                          />
                        )}
                      </div>
                    </div>
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && getConfirmedCompleted() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 4} // Update indices as needed!
                    index={4}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      basic
                      content="Documents"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 4}>
                    <JobDocuments
                      selectedJob={selectedJob}
                      loginContext={loginContext}
                      getDownloadUrl={getDownloadUrl}
                    />
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && !isCSR && getConfirmedCompleted() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 5}
                    index={5}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      basic
                      content="Rating"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 5}>
                    <StarRating
                      selectedJob={selectedJob}
                      setSelectedJob={setSelectedJob}
                      selectedReporter={selectedReporter}
                      handleChangeFieldString={handleChangeFieldString}
                    />
                  </Accordion.Content>
                </div>
              )}

              {getSidebar() && getConfirmedCompleted() && (
                <div style={{ padding: "10px" }}>
                  <Accordion.Title
                    active={activeMenu === 6}
                    index={6}
                    style={{ display: "flex" }}
                    onClick={handleAccordionClick}
                  >
                    <Label
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        width: "100%",
                      }}
                      basic
                      content="Billing"
                      size="big"
                      icon="dropdown"
                      iconPosition="right"
                    />
                  </Accordion.Title>
                  <Accordion.Content active={activeMenu === 6}>
                    <Invoice
                      selectedJob={selectedJob}
                      getStatus={getStatus}
                      servicesList={servicesList}
                      serviceTotal={serviceTotal}
                      setServiceTotal={setServiceTotal}
                      isCSR={isCSR}
                      isAttorney={isAttorney}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      {isCSR && (
                        <Popup
                          onClick={(e) => e.stopPropagation()} // Prevent click from closing the nested popup
                          on="click"
                          open={isGetPaidNow}
                          onOpen={() => setGetPaidNow(true)}
                          onClose={() => setGetPaidNow(false)}
                          trigger={
                            <Button
                              className={
                                getPayoutButtonDisabled()
                                  ? "rainbow-background rainbow-background-disabled custom-button"
                                  : "rainbow-background custom-button"
                              }
                              primary
                              content="Get Paid Now"
                              size="large"
                              onClick={() => setGetPaidNow(true)}
                            />
                          }
                          content={
                            <GetPaidNow handleUpdateJob={handleUpdateJob} />
                          }
                        />
                      )}
                      {!isAttorney && (
                        <Popup
                          open={isConfirmInvoice}
                          content={
                            <div>
                              <Header
                                content="Ready to Generate Invoice"
                                subheader="An invoice will be created and sent to the customer for payment. Once the invoice is sent, you will have the option to GET PAID NOW while we await payment from the customer."
                              />
                              <Button
                                positive
                                content="Yes"
                                onClick={handleGenerateInvoice}
                              />
                              <Button
                                negative
                                content="No"
                                onClick={() => setConfirmInvoice(false)}
                              />
                            </div>
                          }
                          trigger={
                            <Button
                              positive
                              disabled={getGenerateDisabled()}
                              loading={isGenerating}
                              size="large"
                              content="Generate Invoice"
                              onClick={() =>
                                setConfirmInvoice(!isConfirmInvoice)
                              }
                            />
                          }
                        />
                      )}
                    </div>
                  </Accordion.Content>
                </div>
              )}
            </Accordion>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 20,
          background:
            "linear-gradient(to top, rgba(241,241,241,0.98) 80%, rgba(241,241,241,0.0))",
          padding: "1.5rem 0",
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 300,
            pointerEvents: "auto",
            padding: "0 2rem",
          }}
        >
          <Button
            icon="save"
            disabled={editDisabled}
            loading={updating}
            positive
            content="Save Changes"
            size="large"
            onClick={() => handleUpdateJob()}
          />
        </div>
      </div>
    </div>
  );
};
export default Jobs;
